export const SET_USERNAME = (state, username) => {
    state.loginusername = username;
}
